import Grid from '@material-ui/core/Grid';
import { WELL_GUARDIAN_PATHS } from 'constants/paths';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { matchPath, useRouteMatch } from 'react-router-dom';

import styles from './BasicHeader.module.scss';

const BasicHeader: React.FunctionComponent = () => {
  const { path } = useRouteMatch();
  const intl = useIntl();

  const pageKey = useMemo(
    () =>
      Object.keys(WELL_GUARDIAN_PATHS).find(key =>
        matchPath(path, {
          path: WELL_GUARDIAN_PATHS[key as keyof typeof WELL_GUARDIAN_PATHS],
          exact: true,
        }),
      ),
    [path],
  );

  return (
    <Grid item className={styles.pageTitle} data-testid={`basic-header-${pageKey}`}>
      <h1>{intl.formatMessage({ id: `header.pages.${pageKey}` })}</h1>
    </Grid>
  );
};

export default BasicHeader;
